import React from "react";
import { Accordion } from "react-bootstrap";

const CustomAccordion = ({ data, children }) => {
  return (
    <Accordion style={{ marginTop: "30px" }}>
      <Accordion.Item eventKey="0" className={" accordion_button"}>
        <Accordion.Header>{data?.title}</Accordion.Header>
        <Accordion.Body>{children}</Accordion.Body>
      </Accordion.Item>
    </Accordion>
  );
};

export default CustomAccordion;
